<template>
  <SurveyForm @on-submit-clone="cloneSurvey" :isCloneSurvey="true" />
</template>
<script>
import SurveyForm from "./SurveyForm.vue";
import { Message } from "@/helpers/utils";
import { service_names } from "@/constants/Services";
import { survey_router_names } from "@/routes/routes";

export default {
  components: {
    SurveyForm
  },
  methods: {
    cloneSurvey(dataSurvey) {
      this.$axios
        .post(`${service_names.school}/survey`, dataSurvey)
        .then(() => {
          Message.success(this.$t("common.clone_success"));
          this.$router.push({ name: survey_router_names.listPage });
        });
    }
  }
};
</script>
